import React, { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  TextField,
  Checkbox,
  Box,
  Button,
} from "@material-ui/core";
import { kioskModeAPI } from "../../apis/deviceControlApi";
import { useTranslation } from "../../langs/useTranslation";
import useStyles from "../../styles/dialogStyle";
import { StyledSubmitBtn, BackBtn } from "../commons/FormBtns";
import SelectDate from "./SelectDatePicker";
import {
  getAutocompleteApi,
  createAutocompleteApi
} from "../../apis/autocompleteAPI";
import moment from "dayjs";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { MissingSelectedErrorText } from "../commons/StyledTexts";
import AddAppModal from "@/containers/ProfileConfig/CreateTemplate/AndroidConfig/AppConfig/AddAppModal";
import { useDebounceFn } from "ahooks";
import { ReactRender } from "@/components/ReactRender";
import DataTable from "@/components/DataTable";
import UploadAndroidAppDialog from "@/containers/AndroidApp/UploadAndroidAppDialog"

const PackageIdEditText = ({
  value,
  onChange,
  readOnly,
  rowNumber,
  lastFoused
}) => {
  const { run: handleChange } = useDebounceFn(
    (value, type, index) => {
      onChange(old => {
        const newData = [...old]
        newData[index][type] = value
        return newData
      })
    },
    { wait: 800 }
  );
  // const [packageId, setPackageid] = useState("")

  if (readOnly) {
    return <>{value}</>;
  }

  return (
    <TextField
      size="small"
      variant="outlined"
      defaultValue={value}
      autoFocus={rowNumber === lastFoused.current}
      onFocus={() => {
        lastFoused.current = rowNumber;
      }}
      onChange={e => {
        // handleChange(e.target.value, "package_id", rowNumber);
      }}
      onKeyDown={e => {
        if (e.key === "Enter") {
          const value = e.target.value
          onChange(old => {
            const newData = [...old]
            newData[rowNumber]["package_id"] = value
            return newData
          })
        }
      }}
      style={{ width: 300 }}
    />
  );
};

const KioskMode = props => {
  const classes = useStyles();
  const { t } = useTranslation("deviceControl");
  const [selectDateType, setSelectDateType] = useState("immediately");
  const [switchValue, setSwitchValue] = useState("");
  const [checkedWindows, setCheckedWindows] = useState(false);
  const [checkedAndroid, setCheckedAndroid] = useState(false);
  const [error, setError] = useState("");
  const [selectDate, setSelectDate] = useState(new Date());
  const [command, setCommand] = useState("");
  const [enableApplicationAndroid, setEnableApplicationAndroid] = useState("");
  const [enableApplicationWindows, setEnableApplicationWindows] = useState("");
  const [loading, setLoading] = useState(false);
  const [windowsAutoData, setWindowsAutoData] = useState([]);
  const [androidAutoData, setAndroidAutoData] = useState([]);
  const [commandAutoData, setCommandAutoData] = useState([]);
  const [mode, setMode] = useState(1);
  const [addAppOpen, setAddAppOpen] = useState(false);
  const [apps, setApps] = useState([])
  const [forceInstall, setForceInstall] = useState(false)
  const [uploadOpen, setUploadOpen] = useState(false)
  const lastFoused = useRef(null);

  const {
    open,
    setOpen,
    kioskMode,
    selectType,
    selectDevices,
    selectDevice,
    numType,
    groupId,
    tagId,
    selectCompany,
    checkAll,
    setKioskMode,
  } = props;

  const onClose = () => {
    setOpen(false);
  };

  const onConfirm = async () => {
    try {
      if (switchValue === "true") {
        if (apps.length === 0) {
          setError(t({ defaultMessage: "必须添加一个应用" }));
          return;
        }
      }
      setLoading(true);
      const successText = "dialog.successText";
      const res = await kioskModeAPI(
        selectType,
        selectCompany,
        checkAll
          ? undefined
          : numType === "single"
            ? [selectDevice]
            : selectDevices,
        groupId,
        tagId,
        "kiosk_mode",
        switchValue === "true",
        // enableApplicationAndroid,
        (apps && apps.length)? apps[0].package_id: "",
        enableApplicationWindows,
        checkedWindows,
        checkedAndroid,
        selectDate,
        null,
        command,
        t,
        successText,
        switchValue === "false",
        "android",
        {
          mode,
          applications: apps,
          force_reinstall: forceInstall,
          enable_application_android: true
          // enable_application_android: apps && apps.length && apps[0].package_id
        }
      );
      if (res) {
        setOpen(false);
        setKioskMode?.(switchValue === "true");
        if (command) {
          await createAutocompleteApi("kioskmode_command", command);
        }
        if (checkedAndroid && enableApplicationAndroid) {
          await createAutocompleteApi(
            "kioskmode_android_startup",
            enableApplicationAndroid
          );
        }
        if (checkedWindows && enableApplicationWindows) {
          await createAutocompleteApi(
            "kioskmode_windows_startup",
            enableApplicationWindows
          );
        }
      }
    } finally {
      setLoading(false);
    }
  };

  const selectDateHandler = async date => {
    const dateValue = date.valueOf();
    const dateMomentInUTC = moment(dateValue);
    setSelectDate(dateMomentInUTC);
  };

  const selectDateTypeHandler = e => {
    setSelectDateType(e.target.value);
  };

  const switchHandler = e => {
    setSwitchValue(e.target.value);
  };

  const getAutoComplete = async () => {
    let commandData = await getAutocompleteApi("kioskmode_command", "");
    let windowsData = await getAutocompleteApi("kioskmode_windows_startup", "");
    let androidData = await getAutocompleteApi("kioskmode_android_startup", "");
    if (commandData?.commands) {
      setCommandAutoData(commandData.commands);
    }
    if (windowsData?.commands) {
      setWindowsAutoData(windowsData.commands);
    }
    if (androidData?.commands) {
      setAndroidAutoData(androidData.commands);
    }
  };
  useEffect(() => {
    if (open) {
      getAutoComplete();
      setCommand("");
      setEnableApplicationAndroid("");
      setEnableApplicationWindows("");
      setCheckedAndroid(false);
      setCheckedWindows(false);
      setSwitchValue(kioskMode.toString());
      setSelectDateType("immediately");
      setSelectDate(new Date());
    }
  }, [open, kioskMode]);

  const handleAddByPackageId = () => {
    lastFoused.current = null;
    setApps(apps => {
      return [...apps, {
        "package_id": "",
        "version": ""
      }]
    })
  }

  const columns = [
    {
      data: "package_id",
      title: t({ defaultMessage: "应用程序ID" }),
      orderable: false,
      createdCell: (td, data, row, rowNumber) => {
        ReactRender(
          <>
            {!data ? (
              <PackageIdEditText
                lastFoused={lastFoused}
                value={row.package_id}
                onChange={setApps}
                // readOnly={readOnly}
                rowNumber={rowNumber}
              />
            ) : (
              data
            )}
          </>,
          td
        );
      }
    },
    {
      data: "version",
      title: t({ defaultMessage: "版本" }),
      orderable: false
    },
    {
      data: null,
      title: t({ defaultMessage: "操作" }),
      className: "center nowrap",
      searchable: false,
      orderable: false,
      width: 80,
      createdCell: (td, data, row, rowNumber) => {
        ReactRender(
          <Button
            size="small"
            color="primary"
            // disabled={readOnly}
            onClick={() => {
              lastFoused.current = null;
              setApps(apps => {
                return apps.filter(
                  (app, i) => i !== rowNumber
                )
              });
            }}
          >
            {t({ defaultMessage: "移除" })}
          </Button>,
          td
        );
      }
    }
  ]

  return (
    <Dialog
      maxWidth="md"
      className={classes.dialog}
      onClose={onClose}
      open={open}
      aria-labelledby="add-event-dialog"
      aria-describedby="add-event-dialog"
    >
      <DialogTitle id="add-edit-alarm-notification">
        {t("common.kioskModeAndroid")}
      </DialogTitle>
      <>
        <DialogContent>
          <div className={classes.deviceControlDialogOuter}>
            <div className="deviceControlDialogBlock">
              <div className="title">1. {t("common.selectDate")}</div>
              <div className="selectdateArea">
                <FormControl component="div" fullWidth={true}>
                  <RadioGroup
                    aria-label="date"
                    value={selectDateType}
                    onChange={selectDateTypeHandler}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value="immediately"
                            label={`${t("common.immediateText")}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value="scheduling"
                            label={`${t("common.schedulingText")}`}
                            control={<Radio color="primary" />}
                          />
                          <SelectDate
                            selectDateHandler={selectDateHandler}
                            selectDate={selectDate}
                            disabled={
                              selectDateType !== "scheduling" ? true : false
                            }
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </div>
            </div>

            <div className="deviceControlDialogBlock">
              <div className="title">2. {t("common.kioskModeSwitch")}</div>

              <div className="selectdateArea">
                <FormControl component="div" fullWidth={true}>
                  <RadioGroup
                    aria-label="date"
                    value={switchValue}
                    onChange={switchHandler}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value={"true"}
                            label={`${t("common.onSwitch")}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value={"false"}
                            label={`${t("common.offSwitch")}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </div>
            </div>
            {switchValue === "true" && (
              <div className="deviceControlDialogBlock">
                <div className="title">
                  3. {t({ defaultMessage: "Kiosk 模式选择" })}
                </div>
                <FormControl component="div" fullWidth={true}>
                  <RadioGroup
                    aria-label="date"
                    value={mode}
                    onChange={e => setMode(Number(e.target.value))}
                  >
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value={1}
                            label={`${t({ defaultMessage: "单应用模式" })}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid>
                      {/* <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl>
                          <FormControlLabel
                            value={2}
                            label={`${t({defaultMessage: "多应用模式"})}`}
                            control={<Radio color="primary" />}
                          />
                        </FormControl>
                      </Grid> */}
                    </Grid>
                  </RadioGroup>
                </FormControl>
                <Box marginTop={3} marginBottom={3}>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ minWidth: 118 }}
                    onClick={() => setAddAppOpen(true)}
                    disabled={apps.length}
                  >
                    {t({ defaultMessage: "添加应用" })}
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ minWidth: 118, marginLeft: 16 }}
                    onClick={handleAddByPackageId}
                    disabled={apps.length}
                  >
                    {t({ defaultMessage: "手动新增应用程序" })}
                  </Button>
                  <Button
                    variant="outlined"
                    color="primary"
                    style={{ minWidth: 118, marginLeft: 16 }}
                    onClick={() => setUploadOpen(true)}
                    disabled={apps.length}
                  >
                    {t({ defaultMessage: "本地档案上传" })}
                  </Button>
                </Box>
                <DataTable
                  options={{ serverSide: false }}
                  data={apps}
                  columns={columns}
                  paging={false}
                  showCheckAll={false}
                  showFooter={false}
                  autoLoad
                />
                <FormControlLabel
                  control={(
                    <Checkbox
                      checked={forceInstall}
                      onChange={e => setForceInstall(e.target.checked)}
                      name={t({defaultMessage: "若设备已存在app，移除原本版本重新安装"})}
                    />
                  )}
                  label={t({defaultMessage: "若设备已存在app，移除原本版本重新安装"})}
                />
                {error && <FormHelperText error>{error}</FormHelperText>}
              </div>
            )}
          </div>
        </DialogContent>

        <DialogActions className={classes.noMarginBtn}>
          <StyledSubmitBtn
            btnColor="primary"
            type="button"
            disabled={loading}
            btnText={t("dialog.confirmBtn")}
            onClick={onConfirm}
          />
          <BackBtn onClick={onClose} btnText={t("dialog.cancel")} />
        </DialogActions>
      </>
      <UploadAndroidAppDialog
        open={uploadOpen}
        onClose={() => setUploadOpen(false)}
        onSuccess={(data) => {
          setApps(apps => {
            return [...apps,
              {
                id: "",
                name: data.name,
                version: data.version,
                update_at: "",
                size: data.size,
                file_path: data.file_path,
                md5: data.md5,
                package_id: data.package_id,
                version_code: data.version_code,
              }
            ]
          })
        }}
      />
      {addAppOpen && (
        <AddAppModal
          single
          open={addAppOpen}
          onClose={() => setAddAppOpen(false)}
          enableSubVersion={false}
          // checked={checked}
          onConfirm={result => {
            setApps(apps => {
              return result.map(data => ({
                id: data.id,
                name: data.name,
                version: data.version,
                update_at: data.update_at,
                size: data.size,
                file_path: data.file_path,
                md5: data.md5,
                package_id: data.package_id,
                version_code: data.version_code,
              }))
            })
            // onChange({
            //   target: {
            //     name: "applicationBlacklist.applications",
            //     value: result.map(data => ({
            //       id: data.id,
            //       name: data.name,
            //       version: data.version,
            //       update_at: data.update_at,
            //       size: data.size,
            //       package_id: data.package_id
            //     }))
            //   }
            // });
            setAddAppOpen(false);
          }}
        />
      )}
    </Dialog>
  );
};

export default KioskMode;
